import React, { createContext, useContext, useState, ReactNode } from 'react'

interface User {
  docType: string,
  docId: string,
  birthdate: string,
  healthInsurance: string,
  medicalplan: string,
  name: string,
  phone: string,
  secondaryPhone: string,
  email: string,
  lastName: string,
  motherLastName: string,
  patientCod: string,
}

export interface MedicalDate {
  medico: string,
  docId: string,
  dia: Date,
  hourId: string,
  hora: string,
  isPreRegister: boolean
}

interface UserContextProps {
  user: User;
  setUser: (user: User) => void;
  date: MedicalDate;
  setDate: (date: MedicalDate) => void;
}

const UserContext = createContext<UserContextProps | undefined>(undefined);

const UserProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<User>({
    docType: '',
    lastName: '',
    motherLastName: '',
    phone: '',
    secondaryPhone: '',
    email: '',
    docId: '',
    birthdate: '',
    healthInsurance: '',
    medicalplan: '',
    name: '',
    patientCod: '',
  });
  const [date, setDate] = useState<MedicalDate>({
    medico: '',
    docId: '',
    dia: new Date(),
    hourId: '',
    hora: '',
    isPreRegister: false
  });
  return (
    <UserContext.Provider value={{ user, setUser, date, setDate }}>
      {children}
    </UserContext.Provider>
  )
}

export const useUser = (): UserContextProps => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

export default UserProvider
